import React, { useCallback, useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useSlate } from 'slate-react';
import { FormControl, OutlinedInput } from '@material-ui/core';

import { SLATE_TEXT_FORMATS } from '../../../../const';
import { insertLink, HOVERING_TOOLBAR_POSITIONS } from '../../../../utils';
import { HoveringToolbar } from '../../../HoveringToolbar';
import { useStyles } from './useStyles';

export const LinkInsertPopup = ({ setIsOpen }) => {
  const [value, setValue] = useState('');
  const styles = useStyles();
  const editor = useSlate();
  const inputRef = useRef();

  const handleDismiss = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    const selectionPath = editor.selection.anchor.path;
    let currentChild = editor.children[selectionPath[0]];
    let linkChild;

    for (let i = 1; i < selectionPath.length; i++) {
      if (currentChild.type === SLATE_TEXT_FORMATS.LINK) {
        linkChild = currentChild;
        break;
      }
      currentChild = currentChild.children[selectionPath[i]];
    }

    setValue(linkChild?.url);
  }, [editor]);

  useEffect(() => {
    if (inputRef) {
      inputRef.current.focus();
    }
  }, [inputRef]);

  const handleEnterPress = (event) => {
    if (event.key === 'Enter' && !!value.trim()) {
      insertLink(editor, value);
    }
  };

  const handleChange = useCallback((e) => {
    setValue(e.target.value);
  }, []);

  return (
    <HoveringToolbar
      className={styles.root}
      position={HOVERING_TOOLBAR_POSITIONS.bottom}
      onDismiss={handleDismiss}
      preventOnMouseDownEvent
      forceVisibility
    >
      <FormControl className={styles.inputForm}>
        <OutlinedInput
          value={value}
          onChange={handleChange}
          className={styles.input}
          placeholder="Insert a URL"
          onKeyDown={handleEnterPress}
          inputRef={inputRef}
        />
      </FormControl>
    </HoveringToolbar>
  );
};

LinkInsertPopup.propTypes = {
  setIsOpen: PropTypes.func,
};
